export const isAssetImport = (entity) => ['assets', 'assetsGeneral'].includes(entity);

export const isGeneralImport = (entity) => ['assetsGeneral', 'vulnsGeneral'].includes(entity);

export const buildUploadParams = ({
  entity,
  file,
  resolveHost,
  minSeverity,
  maxSeverity,
  hasAssetsTags,
  hasVulnsTags,
  hasServicesTags,
  tags
}) => {
  const params = [
    { name: 'file', value: file },
    { name: 'resolve_hostname', value: resolveHost }
  ];

  if (!isAssetImport(entity)) {
    params.push(
      { name: 'min_severity', value: minSeverity.severity },
      { name: 'max_severity', value: maxSeverity.severity }
    );
  }

  if (hasAssetsTags) params.push({ name: 'host_tag', value: tags });
  if (hasVulnsTags) params.push({ name: 'vuln_tag', value: tags });
  if (hasServicesTags) params.push({ name: 'service_tag', value: tags });

  return params;
};
